// extracted by mini-css-extract-plugin
export default {"AdditonalsView":"styles_AdditonalsView__UusbG","firstAbsoluteAdditional":"styles_firstAbsoluteAdditional__RW0s5","secondAbsoluteAdditional":"styles_secondAbsoluteAdditional__ucn4q"};